/* globals document */

import React from 'react';
import { block } from 'bem-cn';

import { KEYBOARD_KEYS } from '../../constants';
import './pion-editable-title.scss';

const b = block('pion-editable-title');

type PionEditableTitlePropsType = {
  title: string;
  onFinishEdit: (title: string) => void;
};

type PionEditableTitleStateType = {
  title: string;
};

class PionEditableTitle extends React.Component<
  PionEditableTitlePropsType,
  PionEditableTitleStateType
> {
  wrapperRef = React.createRef<HTMLDivElement>();
  inputRef = React.createRef<HTMLInputElement>();

  static defaultProps: { title: string; onFinishEdit: () => void };

  constructor(props: PionEditableTitlePropsType) {
    super(props);
    this.state = {
      title: props.title || '',
    };
  }

  componentDidMount() {
    // eslint-disable-next-line no-unused-expressions
    this.inputRef.current?.focus?.();
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keypress', this.handleKeyPress);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keypress', this.handleKeyPress);
  }

  handleSubmit = () => {
    this.props.onFinishEdit(this.state.title);
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ title: event.target.value });
  };

  handleClickOutside = (event: MouseEvent): any => {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event?.target as Node)
    ) {
      this.props.onFinishEdit(this.state.title);
    }
  };

  handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === KEYBOARD_KEYS.ENTER.KEY) {
      this.props.onFinishEdit(this.state.title);
    }
  };

  render() {
    const { title } = this.state;

    return (
      <div ref={this.wrapperRef} className={b()}>
        <input
          data-testid='pion-title-input'
          ref={this.inputRef}
          className={b('input').mix('card-title-normal')}
          type='text'
          value={title}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export default PionEditableTitle;
